var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"to":_vm.menuItem.route}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(_vm.menuItem.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.menuItem.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }